var generateAction = function generateAction(_ref) {
  var baseActionCreatorName = _ref.baseActionCreatorName,
    baseActionTypeName = _ref.baseActionTypeName;
  var actions = {
    baseAction: {
      type: baseActionTypeName,
      actionCreatorName: baseActionCreatorName,
      creator: function creator(duck) {
        return function (_ref2) {
          var payload = _ref2.payload;
          return Object.assign({
            type: duck.types[baseActionTypeName]
          }, payload);
        };
      }
    },
    successAction: {
      type: baseActionTypeName + "_SUCCESS",
      actionCreatorName: baseActionCreatorName + "Success",
      creator: function creator(duck) {
        return function (_ref3) {
          var payload = _ref3.payload;
          return {
            type: duck.types[baseActionTypeName + "_SUCCESS"],
            payload: payload
          };
        };
      }
    },
    errorAction: {
      type: baseActionTypeName + "_ERROR",
      actionCreatorName: baseActionCreatorName + "Error",
      creator: function creator(duck) {
        return function (_ref4) {
          var payload = _ref4.payload,
            error = _ref4.error;
          return {
            type: duck.types[baseActionTypeName + "_ERROR"],
            payload: payload,
            error: error
          };
        };
      }
    }
  };
  var actionsArray = Object.values(actions);
  var types = actionsArray.map(function (_ref5) {
    var type = _ref5.type;
    return type;
  });
  var creators = function creators(duck) {
    return actionsArray.reduce(function (acc, _ref6) {
      var creator = _ref6.creator,
        actionCreatorName = _ref6.actionCreatorName;
      /* eslint-disable-next-line no-param-reassign */
      acc[actionCreatorName] = creator(duck);
      return acc;
    }, {});
  };
  return {
    types: types,
    creators: creators
  };
};

export { generateAction as default };
//# sourceMappingURL=index.js.map
